// src/components/Sidebar.js
import React from 'react';
import { Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const items = [
        { key: '/dashboard', label: 'Dashboard' },
        { key: '/collections', label: 'Collections' },
        { key: '/sat-collections', label: 'SatCollections' },
        // { key: '/users', label: 'Users' },
        {
            key: '/more',
            label: 'More',
            children: [
                { key: '/settings', label: 'Settings' },
                { key: '/profile', label: 'Profile' },
            ],
        },
    ];

    const handleMenuClick = ({ key }) => {
        navigate(key);
    };

    return (
        <Menu
            mode="inline"
            items={items}
            selectedKeys={[location.pathname]}
            onClick={handleMenuClick}
            style={{ height: '100%', borderRight: 0 }}
        />
    );
};

export default Sidebar;
